module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("foM4l"))).then(() => parcelRequire('hEqeo'));